import React, { useEffect, useMemo } from "react";
import _, { first } from 'lodash'
import { Button, Card, CardContent, Grid, IconButton, List, ListItem, ListItemText, MenuItem, Select, Stack, Tab, Tabs, Typography } from "@mui/material";
import Settings from "@mui/icons-material/Settings";
import LocalFalconSettings from "./localFalconSettings";
import { useDispatch, useSelector } from "react-redux";
import ReactJson from "react-json-view";
import { localFalconSelector, scanLocationData, getScanReportData } from "../../../store/slices/localFalcon";
import { convertArrayToDictionary } from "../../../common/utils";
import { locationsSelector } from "../../../store/slices/location";
import moment from "moment";
import FormattedOutput from "./formattedOutput";
const shouldCollapseFunc = (namespace,data,level) => {
    // console.log('data,level',data,level,namespace)
  if(namespace?.namespace?.length>2){
    return true}
    return false
   
};
const Index = ({ locations }) => {
    const dispatch = useDispatch();
    const [tabValue, setTabValue] = React.useState(1);
    const [selectedLocation, setSelectedLocation] = React.useState({});
    const [selectedLocationFalconData, setSelectedLocationFalconData] = React.useState({});
    const [formdata, setFormdata] = React.useState({ gridSize: 5 });
    const { users } = useSelector(locationsSelector)
    const [settingsModal, setSettingsModal] = React.useState(false);
    const { scanReport } = useSelector(localFalconSelector)
    const scanReportMemo = useMemo(() => _.orderBy(_.map([...scanReport], it => ({ ...it, parsedOutput: JSON.parse(it?.output) })), 'runOn', 'desc'), [scanReport])
    const locationsMemo = useMemo(() => _.orderBy(_.uniqBy(_.filter(locations, it => it.sourceType === 1), 'locationId'), 'name'), [locations]);
    const locationsDic = useMemo(() => convertArrayToDictionary(locationsMemo, 'sourcePlaceId'), [locationsMemo]);
    const usersDic = useMemo(() => convertArrayToDictionary(users, 'userId'), [users]);
    const handleSelectedLocation = (event) => {
        const location = _.find(locationsMemo, { locationId: event.target.value });
        setSelectedLocation(location);
        setSelectedLocationFalconData({})
    }
    useEffect(() => {
        if (!_.isEmpty(locationsMemo)) {
            setSelectedLocation(locationsMemo[0])
        }
    }, [locationsMemo])
    useEffect(() => {
        if (!_.isEmpty(selectedLocation)) {
            setFormdata({ lat: _.toString(selectedLocation.latitude), lng: _.toString(selectedLocation.longitude), sourceId: selectedLocation.sourceId, placeId: selectedLocation.sourcePlaceId, gridSize: 5, radius: 2 })
        }
        dispatch(getScanReportData(selectedLocation.sourceId))
    }, [selectedLocation])
    // useEffect(() => {
    //     if(!_.isEmpty(scanReportMemo)){
    //         setSelectedLocationFalconData(scanReportMemo[0])
    //     }
    // }, [scanReportMemo])
    const onRun = () => {

        dispatch(scanLocationData({ ...formdata }))

    }
    const onSetSelectedParam = (value) => {
        setSelectedLocationFalconData(value)
    }
    const getBackgroundCOlor = (value, theme, bgColor) => {
        if (selectedLocationFalconData?.localFalconScanId === value?.localFalconScanId) {
            if (bgColor) {
                return { bgColor: '#d9edfd' }
            }
            return { borderColor: theme.palette.primary.main }
        }
        return { bgColor: '#fff', borderColor: theme.palette.divider }

    }
    const getUserName = (value) => {
        const firstName = _.startCase(usersDic[value]?.firstName ?? "")
        const lastName = _.startCase(usersDic[value]?.lastName ?? "")

        return firstName + ' ' + lastName
    }
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue)
    }

    return <Grid container columns={10} pt={1} spacing={2}>
        <Grid item xs={4} sx={{ height: 'calc(100vh - 125px)', flexDirection: 'column', display: 'flex', gap: 2 }}>
            <Stack spacing={2} direction={'row'} justifyContent={'space-between'} sx={{ width: '100%' }}>
                <Select fullWidth
                    value={selectedLocation?.locationId ?? ''}
                    onChange={handleSelectedLocation}
                    size="small"
                >
                    {_.map(locationsMemo, (location) => (
                        <MenuItem value={location?.locationId} key={location?.locationId}>

                            {location.name}

                        </MenuItem>
                    ))}
                </Select>


                <Button fullWidth sx={{ maxWidth: '120px' }} variant="contained" color="primary" onClick={() => setSettingsModal(true)} disabled={_.isEmpty(selectedLocation)}  >Run Scan</Button>

                {settingsModal && <LocalFalconSettings onSave={onRun} formdata={formdata} setFormdata={setFormdata} open={settingsModal} handleClose={() => setSettingsModal(false)} location={selectedLocation} />}
            </Stack>
            <List sx={{
                width: '100%', overflow: 'auto',

                p: 0,
                flex: 1,
                overflowY: 'auto',
            }}>
                {_.map([...scanReportMemo], (item, index) => (
                    <ListItem onClick={() => onSetSelectedParam(item)} sx={{ cursor: 'pointer' }} key={item?.localFalconScanId}>
                        <Card sx={{ backgroundColor: theme => getBackgroundCOlor(item, theme, true)?.bgColor, width: '100%', border: '1px solid', borderColor: theme => getBackgroundCOlor(item, theme)?.borderColor, boxShadow: 'none' }} direction={'row'} spacing={1}>
                            <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: '8px', position: 'relative' }}>
                                <Stack direction='row' spacing={1} alignItems={'center'}>
                                    <Typography fontWeight={500}>Keyword:</Typography>
                                    <Typography>{item?.parsedOutput?.parameters.keyword}</Typography>
                                </Stack>
                                <Stack direction='row' spacing={1} alignItems={'center'}>
                                    <Typography fontWeight={500}>Location:</Typography>
                                    <Typography>{locationsDic[item?.parsedOutput?.parameters?.place_id]?.name + ' (' + item?.parsedOutput?.parameters?.place_id + ')'}</Typography>
                                </Stack>
                                <Stack spacing={2} direction={'row'} alignItems={'center'}>
                                    <Stack direction='row' spacing={1} alignItems={'center'}>
                                        <Typography fontWeight={500}>Geolocation:</Typography>
                                        <Typography>{item?.parsedOutput?.parameters.lat}, {item?.parsedOutput?.parameters.lng}</Typography>
                                    </Stack>
                                    <Stack direction='row' spacing={1} alignItems={'center'}>
                                        <Typography fontWeight={500}>Grid Size:</Typography>
                                        <Typography>{item?.parsedOutput?.parameters.grid_size}x{item?.parsedOutput?.parameters.grid_size} ({item?.parsedOutput?.parameters.radius}{item?.parsedOutput?.parameters.measurement})</Typography>
                                    </Stack>
                                </Stack>
                                <Typography sx={{ position: 'absolute', left: '16px', bottom: 4 }} variant="caption" className="text-muted" fontStyle={'italic'}>Run by {getUserName(item?.runBy)} on {moment
                                    .utc(item?.runOn)
                                    .local()
                                    .format("MM/DD/YYYY hh:mm A")}</Typography>


                            </CardContent>
                        </Card>
                    </ListItem>
                ))}
            </List>

        </Grid>
        <Grid item xs={6} sx={{ height: 'calc(100vh - 190px)', flexDirection: 'column', display: 'flex', gap: 2 }}>
            <Tabs value={tabValue} onChange={handleTabChange} sx={{ borderBottom: '1px  solid', borderColor: theme => theme.palette.divider }}>
                <Tab value={1} label="Formatted Output" />
                <Tab value={2} label="Raw Output" />
            </Tabs>
            {!_.isEmpty(selectedLocationFalconData) && tabValue === 2 && <ReactJson
                style={{

                    whiteSpace: "pre-wrap",
                    border: "1px solid #ccc",
                    minHeight: '100px',
                    overflow: 'auto',
                    flex: 1
                }}
                src={(() => {
                    try {
                        return selectedLocationFalconData?.parsedOutput?.data
                    } catch (error) {
                        return console.warn("Invalid JSON")
                    }
                })()}
                name={null}
                defaultValue={null}
                theme="rjv-default"
                collapsed={false}
                // groupArraysAfterLength={5}
                enableClipboard={false}
                displayDataTypes={false}
                shouldCollapse={shouldCollapseFunc}
            />}
            {tabValue === 1 && <FormattedOutput selectedLocationFalconData={selectedLocationFalconData} data={selectedLocationFalconData?.parsedOutput?.data} selectedPlaceId={selectedLocationFalconData?.parsedOutput?.parameters?.place_id} mapRange={selectedLocationFalconData?.parsedOutput?.parameters} />}

        </Grid>
    </Grid>;
};

export default Index;
